import { render, staticRenderFns } from "./ToggleableSectionView.vue?vue&type=template&id=26696d6a"
import script from "./ToggleableSectionView.vue?vue&type=script&lang=js"
export * from "./ToggleableSectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports